import { PlaneGeometry, ShaderMaterial, Mesh } from 'three';
import gsap from 'gsap';
import overlayVertexShader from '../../Shaders/Overlay/overlayVertex.glsl';
import overlayFragmentShader from '../../Shaders/Overlay/overlayFragment.glsl';

export default class FadeOverlay {
    constructor(scene, camera) {
        this.camera = camera;
        const overlayGeometry = new PlaneGeometry(2, 2, 1, 1);
        const overlayMaterial = new ShaderMaterial({
            vertexShader: overlayVertexShader,
            fragmentShader: overlayFragmentShader,
            transparent: true,
            uniforms: {
                uAlpha: { value: 1.0 },
            },
        });
        this.overlay = new Mesh(overlayGeometry, overlayMaterial);
        this.overlay.quaternion.set(camera.quaternion);
        scene.add(this.overlay);
    }

    showOverlay(onComplete) {
        this.overlay.visible = true;
        gsap.to(this.overlay.material.uniforms.uAlpha, {
            duration: 1.0,
            value: 1.0,
            onComplete: onComplete,
        });
    }

    hideOverlay(onComplete) {
        const makeInvisibleOnComplete = () => {
            if (onComplete) onComplete();
            this.overlay.visible = false;
        };
        gsap.to(this.overlay.material.uniforms.uAlpha, {
            duration: 1.0,
            value: 0.0,
            onComplete: makeInvisibleOnComplete,
        });
    }
}
